var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpandArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.579 9.26407L12.4126 12.7994L8.24616 9.26407C7.82736 8.90872 7.15085 8.90872 6.73206 9.26407C6.31327 9.61943 6.31327 10.1935 6.73206 10.5488L11.6609 14.731C12.0797 15.0864 12.7562 15.0864 13.175 14.731L18.1039 10.5488C18.5227 10.1935 18.5227 9.61943 18.1039 9.26407C17.6851 8.91783 16.9978 8.90872 16.579 9.26407Z",
    fill: "#EDEDEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandArrow);
export default __webpack_public_path__ + "static/media/expand_arrow.fde2d181bb53c683e2d07ba4b60ccb95.svg";
export { ForwardRef as ReactComponent };